// =============================================================================
// RequireAuth
// =============================================================================
// Wraps a route to enforce authentication: without a signed-in user the
// visitor goes to /login, and comes back after signing in.
//
// Usage in App.jsx:
//   <Route path="/profile" element={<RequireAuth><Profile /></RequireAuth>} />
// =============================================================================

import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { C, font } from "../styles/tokens";
import { LiquidLoader } from "./LiquidLoader";

export function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          width: "100vw",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#F5F7F9",
        }}
      >
        <LiquidLoader text="Authenticating" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
